export default __webpack_public_path__ + "static/media/image23.cc324154.png";